var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUpOutlinedBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6333 7.30662L12.5082 7.90838H13.1228H18.7596C19.4661 7.90838 20.0462 8.48849 20.0462 9.19498V10.9816C20.0462 11.1444 20.0158 11.295 19.9582 11.4446L17.2637 17.7346L17.2637 17.7346L17.2618 17.7392C17.0698 18.2 16.6149 18.5213 16.0797 18.5213H8.03996C7.33347 18.5213 6.75336 17.9412 6.75336 17.2347V8.30168C6.75336 7.94646 6.8945 7.62873 7.12908 7.40049L7.12912 7.40053L7.13423 7.39541L12.6603 1.86097L13.2517 2.44679C13.2519 2.44705 13.2522 2.4473 13.2524 2.44756C13.399 2.59447 13.4925 2.79972 13.498 3.01952L13.4763 3.25155L12.6333 7.30662ZM3.96676 8.80168V18.5213H1.39355V8.80168H3.96676Z",
    stroke: "#2086E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpOutlinedBlue);
export default __webpack_public_path__ + "static/media/thumbs-up-outlined-blue.53523780.svg";
export { ForwardRef as ReactComponent };